import React, { useState } from 'react';
import HeaderAuth from './HeaderAuth';
import HeroSection from './HeroSection';
import { Footer, FloatingChatButton } from '../common';
import '../../styles/landing.css';

const HomeAuth = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  return (
    <div className="landing-page">
      
      <HeroSection
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Footer />
      <FloatingChatButton />
    </div>
  );
};

export default HomeAuth;
